import React, { useState } from 'react';
import '../App.css';

const trackConversion = (eventName, eventType) => {
    const eventId = 'event_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    if (window.fbq) {
        window.fbq('track', eventType || 'Lead', {
            content_name: eventName,
            content_category: eventType === 'Lead' ? 'WhatsApp Click' : 'Instagram Follow',
            origin: eventName
        }, { eventID: eventId });
    }

    if (window.gtag) {
        window.gtag('event', eventName, {
            'event_category': 'engagement',
            'event_label': 'CTA Click'
        });
    }

    fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            eventName: eventType || 'Lead',
            eventSourceUrl: window.location.href,
            eventId: eventId,
            variant: 'C',
            origin: eventName
        })
    }).catch(err => console.error('CAPI Error:', err));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': eventType === 'Lead' ? 'lead_conversion' : 'instagram_follow',
        'eventCategory': eventType === 'Lead' ? 'Lead' : 'Engagement',
        'eventAction': eventType === 'Lead' ? 'WhatsApp Click' : 'Instagram Click',
        'eventLabel': eventName,
        'eventId': eventId
    });
};

const handleWhatsAppClick = (origin) => {
    trackConversion(`whatsapp_click_${origin}`, 'Lead');

    const messages = {
        'hero': 'Olá! Vi o site da Luppe Saúde e gostaria de agendar uma avaliação!',
        'servicos_facetas': 'Olá! Tenho interesse nas Facetas em Resina e gostaria de saber mais!',
        'servicos_clareamento': 'Olá! Quero saber mais sobre o Clareamento Dental na Luppe Saúde!',
        'servicos_aparelho': 'Olá! Tenho interesse nos Aparelhos Ortodônticos e quero agendar uma avaliação!',
        'servicos_preenchimento': 'Olá! Quero saber mais sobre Preenchimento Labial na Luppe Saúde!',
        'servicos_botox': 'Olá! Tenho interesse no Botox e gostaria de mais informações!',
        'dra': 'Olá! Gostaria de agendar uma consulta com a Dra. Emily Graziele!',
        'cta_final': 'Olá! Quero agendar minha avaliação na Luppe Saúde agora!',
        'sticky_mobile': 'Olá! Quero agendar minha avaliação na Luppe Saúde.',
        'banner': 'Olá! Quero agendar minha avaliação na Luppe Saúde.',
        'social_cta': 'Olá! Vi os resultados de antes e depois e quero transformar meu sorriso também!',
        'localizacao': 'Olá! Gostaria de confirmar o endereço e agendar uma consulta!'
    };

    const message = (messages[origin] || messages['hero']) + ' 🦷';
    window.open(`https://wa.me/5511939300849?text=${encodeURIComponent(message)}`, '_blank');
};

const handleInstagramClick = (origin) => {
    // Dispara Lead (conversão) + InstagramFollow (ação específica)
    trackConversion(`instagram_click_${origin}`, 'Lead');
    trackConversion(`instagram_follow_${origin}`, 'InstagramFollow');
    window.open('https://www.instagram.com/draemilysantos/', '_blank');
};

function ClinicaLP() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [itemsToShow, setItemsToShow] = useState(window.innerWidth <= 768 ? 1 : (window.innerWidth <= 992 ? 2 : 3));
    const [showSticky, setShowSticky] = useState(false);
    const [notificationText, setNotificationText] = useState("");

    const minSwipeDistance = 50;

    React.useEffect(() => {
        let timers = [];

        const stickyTimer = setTimeout(() => {
            setShowSticky(true);

            const firstMsgTimer = setTimeout(() => {
                setNotificationText("Podemos agendar sua avaliação?");

                const hideFirstMsgTimer = setTimeout(() => {
                    setNotificationText("");

                    const secondMsgTimer = setTimeout(() => {
                        setNotificationText("Respondemos em até 5 minutos!");

                        const hideSecondMsgTimer = setTimeout(() => {
                            setNotificationText("");
                        }, 4000);
                        timers.push(hideSecondMsgTimer);
                    }, 8000);
                    timers.push(secondMsgTimer);
                }, 4000);
                timers.push(hideFirstMsgTimer);
            }, 10000);
            timers.push(firstMsgTimer);
        }, 3000);
        timers.push(stickyTimer);

        const handleResize = () => {
            setItemsToShow(window.innerWidth <= 768 ? 1 : (window.innerWidth <= 992 ? 2 : 3));
        };

        window.addEventListener('resize', handleResize);
        return () => {
            timers.forEach(clearTimeout);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const cases = [
        {
            id: '01',
            before: 'Foco em Cor e Brilho',
            after: 'Eliminei o tom amarelado que me incomodava há anos. Impressionante como o brilho voltou em apenas uma tarde, com acabamento super natural e sem qualquer desgaste nos dentes.',
            imgBefore: '/paciente1-antes.webp',
            imgAfter: '/paciente1-depois.webp'
        },
        {
            id: '02',
            before: 'Foco em Alinhamento e Espaços',
            after: 'Os espaços entre os dentes sumiram e o sorriso ficou harmônico. Foi o melhor custo-benefício que encontrei: resultado de aparelho, mas resolvido em uma única sessão rápida.',
            imgBefore: '/paciente2-antes.webp',
            imgAfter: '/paciente2-depois.webp'
        },
        {
            id: '03',
            before: 'Foco em Harmonia Facial',
            after: 'Eu buscava um sorriso simétrico e iluminado. Consegui a estética de capa de revista com investimento acessível e a segurança de um material de altíssima qualidade profissional.',
            imgBefore: '/paciente3-antes.webp',
            imgAfter: '/paciente3-depois.webp'
        },
        {
            id: '04',
            before: 'Foco em Rejuvenescimento',
            after: 'Meus dentes estavam desgastados e com aparência envelhecida. Em poucas horas, recuperei o volume e formato ideal. O rosto todo parece muito mais firme, leve e renovado agora.',
            imgBefore: '/paciente4-antes.webp',
            imgAfter: '/paciente4-depois.webp'
        },
        {
            id: '05',
            before: 'Foco em Correção de Imperfeições',
            after: 'Corrigi irregularidades de forma e tamanho que me impediam de sorrir. Procedimento rápido, indolor e com um polimento que faz toda a diferença no brilho do meu dia a dia.',
            imgBefore: '/paciente5-antes.webp',
            imgAfter: '/paciente5-depois.webp'
        }
    ];

    const servicos = [
        {
            id: 'facetas',
            icon: 'bi-gem',
            titulo: 'Facetas em Resina',
            descricao: 'Transformação completa do sorriso em sessão única. Resultado premium com resina de alta performance, sem desgaste dental.',
            destaque: true,
            tag: 'MAIS PROCURADO'
        },
        {
            id: 'clareamento',
            icon: 'bi-brightness-high',
            titulo: 'Clareamento Dental',
            descricao: 'Dentes até 5 tons mais claros com segurança. Protocolo personalizado para resultados naturais e duradouros.'
        },
        {
            id: 'aparelho',
            icon: 'bi-braces',
            titulo: 'Aparelhos Ortodônticos',
            descricao: 'Alinhamento dental com tecnologia moderna. Avaliação gratuita para descobrir o melhor plano para seu caso.'
        },
        {
            id: 'preenchimento',
            icon: 'bi-droplet',
            titulo: 'Preenchimento Labial',
            descricao: 'Harmonização labial com resultado natural e seguro. Realce sua beleza com técnicas minimamente invasivas.'
        },
        {
            id: 'botox',
            icon: 'bi-slash-circle',
            titulo: 'Botox',
            descricao: 'Relaxamento muscular para suavizar linhas de expressão. Efeito natural, sem perder a expressividade.'
        }
    ];

    const nextSlide = () => {
        const maxIndex = cases.length - itemsToShow;
        setCurrentIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
    };

    const prevSlide = () => {
        const maxIndex = cases.length - itemsToShow;
        setCurrentIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
    };

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        if (isLeftSwipe) {
            nextSlide();
        } else if (isRightSwipe) {
            prevSlide();
        }
    };

    return (
        <div className="App clinica-lp" style={{ overflowX: 'hidden' }}>
            {/* ==========================================
                HERO — PATTERN INTERRUPT + CURIOSITY GAP
               ========================================== */}
            <section className="hero-section wave-bg" style={{ padding: '110px 0 50px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 text-center">
                            <div className="hero-badge" style={{ background: '#33D9FF', color: '#002163', fontWeight: '800' }}>
                                <i className="bi bi-star-fill"></i> GRAJAÚ · ZONA SUL DE SP
                            </div>
                            <h1 className="hero-title">
                                O consultório que está transformando sorrisos no Grajaú
                            </h1>
                            <p className="hero-subtitle">
                                Mesma qualidade da zona nobre de SP, <strong>preço que cabe no seu bolso</strong>. Facetas, Clareamento, Aparelhos, Preenchimento e Botox com a Dra. Emily Graziele.
                            </p>

                            {/* Dual CTA Block */}
                            <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
                                <button
                                    className="cta-button"
                                    onClick={() => handleWhatsAppClick('hero')}
                                >
                                    <i className="bi bi-whatsapp"></i>
                                    AGENDAR NO WHATSAPP
                                </button>
                                <button
                                    className="cta-button"
                                    onClick={() => handleInstagramClick('hero')}
                                    style={{
                                        background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                                        color: '#fff',
                                        boxShadow: '0 4px 15px rgba(220, 39, 67, 0.4)'
                                    }}
                                >
                                    <i className="bi bi-instagram"></i>
                                    SEGUIR A DRA. EMILY
                                </button>
                            </div>

                            <div className="hero-features" style={{ opacity: 0.9 }}>
                                <small>
                                    <i className="bi bi-shield-check"></i> Avaliação gratuita |
                                    <i className="bi bi-clock-fill ms-2"></i> Seg a Sex: 08:00 às 19:00 | Sáb: 09:00 às 14:00 |
                                    <i className="bi bi-whatsapp ms-2"></i> Respondemos em até 5 min
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                SERVIÇOS GRID — 5 CARDS
               ========================================== */}
            <section style={{ background: '#f8f9fa', padding: '60px 0' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="section-title" style={{ color: 'var(--azul-escuro)', fontWeight: '800' }}>
                            Do clareamento à transformação completa
                        </h2>
                        <p style={{ color: '#555', fontSize: '1.1rem' }}>
                            Escolha o serviço ideal para você e fale conosco agora
                        </p>
                    </div>
                    <div className="row g-4">
                        {servicos.map(servico => (
                            <div key={servico.id} className="col-md-6 col-lg-4">
                                <div style={{
                                    background: '#fff',
                                    borderRadius: '16px',
                                    padding: servico.destaque ? '0' : '30px 25px 25px',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    border: servico.destaque ? '3px solid var(--azul-claro)' : '1px solid #e0e0e0',
                                    boxShadow: servico.destaque ? '0 10px 35px rgba(51,153,255,0.2)' : '0 2px 8px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s ease',
                                    overflow: 'hidden'
                                }}>
                                    {servico.destaque && (
                                        <div style={{
                                            background: 'linear-gradient(90deg, var(--azul-claro) 0%, var(--azul-medio) 100%)',
                                            color: '#fff',
                                            textAlign: 'center',
                                            padding: '6px',
                                            fontWeight: '800',
                                            fontSize: '0.8rem',
                                            letterSpacing: '1px'
                                        }}>
                                            {servico.tag}
                                        </div>
                                    )}
                                    <div style={{ padding: servico.destaque ? '25px 25px 20px' : '0' }}>
                                        <div style={{
                                            width: '55px',
                                            height: '55px',
                                            background: 'linear-gradient(135deg, var(--azul-medio), var(--azul-claro))',
                                            borderRadius: '14px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '18px'
                                        }}>
                                            <i className={`bi ${servico.icon}`} style={{ fontSize: '1.6rem', color: '#fff' }}></i>
                                        </div>
                                        <h3 style={{
                                            fontSize: '1.2rem',
                                            fontWeight: '700',
                                            color: 'var(--azul-escuro)',
                                            marginBottom: '10px'
                                        }}>
                                            {servico.titulo}
                                        </h3>
                                        <p style={{
                                            fontSize: '0.9rem',
                                            color: '#555',
                                            lineHeight: '1.6',
                                            flex: '1',
                                            marginBottom: '18px'
                                        }}>
                                            {servico.descricao}
                                        </p>
                                        <button
                                            className="cta-button"
                                            onClick={() => handleWhatsAppClick(`servicos_${servico.id}`)}
                                            style={{
                                                padding: '10px 22px',
                                                fontSize: '0.85rem',
                                                width: '100%',
                                                justifyContent: 'center',
                                                animation: 'none'
                                            }}
                                        >
                                            <i className="bi bi-whatsapp"></i>
                                            Saber mais
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ==========================================
                QUEM É A DRA. — AUTORIDADE
               ========================================== */}
            <section style={{ background: '#fff', padding: '70px 0' }}>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-4 text-center mb-4 mb-lg-0">
                            <img
                                src="https://images.luppesaude.com.br/img/Dra_Emily.jpg"
                                alt="Dra. Emily Graziele - CRO-SP 142110"
                                className="dra-image"
                                style={{
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                    border: '4px solid var(--azul-claro)',
                                    boxShadow: '0 15px 35px rgba(0,33,99,0.2)'
                                }}
                            />
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-badge mb-3" style={{ display: 'inline-block' }}>
                                <i className="bi bi-patch-check-fill"></i> CRO-SP 142110
                            </div>
                            <h2 className="section-title" style={{ color: 'var(--azul-escuro)', fontWeight: '800', marginBottom: '15px' }}>
                                Dra. Emily Graziele
                            </h2>
                            <p style={{ fontSize: '1.1rem', color: '#444', lineHeight: '1.7', marginBottom: '20px' }}>
                                Especialista em estética bucal e harmonização facial, atendo há anos no coração do Grajaú com a missão de tornar o sorriso dos meus pacientes <strong>motivo de orgulho, não de vergonha</strong>.
                            </p>
                            <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6', marginBottom: '25px' }}>
                                Cada paciente recebe um plano individualizado. Não sigo fórmula pronta, porque cada sorriso tem sua própria história e seu próprio potencial.
                            </p>
                            <div className="dra-tags d-flex flex-wrap gap-2 mb-3">
                                <span style={{ background: '#f0f7ff', color: 'var(--azul-medio)', padding: '6px 14px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600' }}>
                                    <i className="bi bi-check-circle-fill me-1"></i> Estética Bucal
                                </span>
                                <span style={{ background: '#f0f7ff', color: 'var(--azul-medio)', padding: '6px 14px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600' }}>
                                    <i className="bi bi-check-circle-fill me-1"></i> Harmonização Facial
                                </span>
                                <span style={{ background: '#f0f7ff', color: 'var(--azul-medio)', padding: '6px 14px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600' }}>
                                    <i className="bi bi-check-circle-fill me-1"></i> Facetas em Resina
                                </span>
                                <span style={{ background: '#f0f7ff', color: 'var(--azul-medio)', padding: '6px 14px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: '600' }}>
                                    <i className="bi bi-check-circle-fill me-1"></i> Ortodontia
                                </span>
                            </div>
                            <button
                                className="cta-button"
                                onClick={() => handleWhatsAppClick('dra')}
                            >
                                <i className="bi bi-whatsapp"></i>
                                AGENDAR COM A DRA. EMILY
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                PROVA SOCIAL — ANTES E DEPOIS
               ========================================== */}
            <section className="prova-social-section wave-bg">
                <div className="container">
                    <div className="text-center mb-4">
                        <h2 className="section-title" style={{ color: 'var(--branco)' }}>
                            Transformações reais no Grajaú
                        </h2>
                        <p className="section-subtitle" style={{ color: 'var(--branco)', opacity: 0.95 }}>
                            Veja como nossos pacientes saem do consultório com outro sorriso
                        </p>
                    </div>

                    <div className="carousel-container">
                        <button className="carousel-control prev" onClick={prevSlide} aria-label="Depoimento anterior">
                            <i className="bi bi-chevron-left"></i>
                        </button>

                        <div
                            className="carousel-track-wrapper"
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        >
                            <div
                                className="carousel-track"
                                style={{
                                    transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)`
                                }}
                            >
                                {cases.map((patient) => (
                                    <div className="carousel-item-custom" key={patient.id}>
                                        <div className="before-after-card">
                                            <div className="before-after-image">
                                                <span className="before-after-label">CASO {patient.id}</span>
                                                <div className="d-flex w-100 h-100">
                                                    <div className="w-50 h-100 border-end d-flex align-items-center justify-content-center bg-light overflow-hidden">
                                                        {patient.imgBefore ? (
                                                            <img
                                                                src={patient.imgBefore}
                                                                alt={`Dentes do paciente ${patient.id} antes do tratamento`}
                                                                width="400"
                                                                height="300"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <span className="text-muted small">ANTES</span>
                                                        )}
                                                    </div>
                                                    <div className="w-50 h-100 d-flex align-items-center justify-content-center overflow-hidden">
                                                        {patient.imgAfter ? (
                                                            <img
                                                                src={patient.imgAfter}
                                                                alt={`Dentes do paciente ${patient.id} depois do tratamento`}
                                                                width="400"
                                                                height="300"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <span className="text-primary small">DEPOIS</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="before-after-content" style={{ padding: '15px', textAlign: 'left' }}>
                                                <p className="mb-0" style={{ fontSize: '0.85rem', color: '#2d3436', lineHeight: '1.4' }}>
                                                    {patient.after}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button className="carousel-control next" onClick={nextSlide} aria-label="Próximo depoimento">
                            <i className="bi bi-chevron-right"></i>
                        </button>

                        <div className="carousel-indicators">
                            {Array.from({ length: cases.length - itemsToShow + 1 }).map((_, idx) => (
                                <button
                                    key={idx}
                                    className={`indicator-dot ${currentIndex === idx ? 'active' : ''}`}
                                    onClick={() => setCurrentIndex(idx)}
                                    aria-label={`Ir para slide ${idx + 1}`}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="text-center mt-4">
                        <button
                            className="cta-button"
                            onClick={() => handleWhatsAppClick('social_cta')}
                        >
                            <i className="bi bi-whatsapp"></i>
                            EU QUERO ESSE RESULTADO TAMBÉM
                        </button>
                    </div>
                </div>
            </section>

            {/* ==========================================
                LOCALIZAÇÃO — CONFIANÇA + PROXIMIDADE
               ========================================== */}
            <section style={{ background: '#fff', padding: '60px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="text-center mb-4">
                                <h2 className="section-title" style={{ color: 'var(--azul-escuro)', fontWeight: '800' }}>
                                    <i className="bi bi-geo-alt-fill" style={{ color: 'var(--azul-claro)' }}></i> Bem no coração do Grajaú
                                </h2>
                            </div>
                            <div className="location-box" style={{
                                background: '#f8fbff',
                                border: '2px dashed var(--azul-claro)',
                                borderRadius: '20px',
                                padding: '35px 30px',
                                textAlign: 'center'
                            }}>
                                <p style={{ fontSize: '1.3rem', color: 'var(--azul-escuro)', fontWeight: '700', marginBottom: '10px' }}>
                                    Avenida Prefeito Paulo Lauro, 889
                                </p>
                                <p style={{ fontSize: '1.05rem', color: '#555', marginBottom: '15px' }}>
                                    Grajaú · São Paulo · SP · CEP 04852-000
                                </p>
                                <p style={{ fontSize: '0.95rem', color: '#666', marginBottom: '20px' }}>
                                    <i className="bi bi-compass"></i> Próximo à Estação Grajaú e Av. Belmira Marin<br />
                                    <i className="bi bi-clock-fill ms-2"></i> Seg a Sex: 08:00 às 19:00 | Sáb: 09:00 às 14:00
                                </p>
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                    <button
                                        className="cta-button"
                                        onClick={() => handleWhatsAppClick('localizacao')}
                                    >
                                        <i className="bi bi-whatsapp"></i>
                                        AGENDAR AVALIAÇÃO
                                    </button>
                                    <button
                                        className="cta-button"
                                        onClick={() => window.open('https://maps.google.com/?q=Avenida+Prefeito+Paulo+Lauro+889+Grajaú+São+Paulo', '_blank')}
                                        style={{ background: '#fff', color: 'var(--azul-escuro)', border: '2px solid var(--azul-claro)', boxShadow: 'none', animation: 'none' }}
                                    >
                                        <i className="bi bi-map-fill"></i>
                                        ABRIR NO MAPS
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                CTA FINAL — DOUBLE ACTION
               ========================================== */}
            <section style={{ background: 'linear-gradient(135deg, var(--azul-escuro) 0%, var(--azul-medio) 100%)', padding: '70px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <h2 className="cta-final-title" style={{ color: '#fff', fontWeight: '900', marginBottom: '15px' }}>
                                Seu sorriso novo começa aqui
                            </h2>
                            <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', marginBottom: '15px' }}>
                                Agende sua avaliação gratuita agora ou siga a Dra. Emily no Instagram para acompanhar as transformações
                            </p>
                            <p style={{
                                color: '#33D9FF',
                                fontWeight: '800',
                                fontSize: '0.95rem',
                                marginBottom: '30px',
                                background: 'rgba(51,217,255,0.1)',
                                display: 'inline-block',
                                padding: '8px 20px',
                                borderRadius: '20px'
                            }}>
                                <i className="bi bi-chat-dots-fill me-1"></i>
                                Respondemos em até 5 minutos no WhatsApp
                            </p>

                            <div className="d-flex flex-wrap justify-content-center gap-3">
                                <button
                                    className="cta-button-large"
                                    onClick={() => handleWhatsAppClick('cta_final')}
                                >
                                    <i className="bi bi-whatsapp"></i>
                                    AGENDAR AVALIAÇÃO GRATUITA
                                </button>
                                <button
                                    className="cta-button-large"
                                    onClick={() => handleInstagramClick('cta_final')}
                                    style={{
                                        background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                                        color: '#fff',
                                        border: 'none',
                                        padding: '22px 40px',
                                        fontSize: '1.1rem',
                                        fontWeight: '700',
                                        borderRadius: '50px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 6px 20px rgba(220, 39, 67, 0.4)'
                                    }}
                                >
                                    <i className="bi bi-instagram"></i>
                                    SEGUIR A DRA. EMILY
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================
                FOOTER
               ========================================== */}
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="footer-logo">
                                <i className="bi bi-heart-pulse-fill"></i> LUPPE SAÚDE
                            </div>
                            <p style={{ fontSize: '1.1rem', marginBottom: '10px' }}>Odontologia</p>

                            <div className="footer-address">
                                <p>
                                    <i className="bi bi-geo-alt-fill"></i>
                                    <strong>Avenida Prefeito Paulo Lauro, 889</strong><br />
                                    <span style={{ marginLeft: '30px' }}>Grajaú, São Paulo - SP</span>
                                </p>
                                <p>
                                    <i className="bi bi-telephone-fill"></i>
                                    <strong>(11) 93930-0849</strong>
                                </p>
                                <p>
                                    <i className="bi bi-instagram"></i>
                                    <a
                                        href="https://www.instagram.com/draemilysantos/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'var(--azul-claro)', textDecoration: 'none' }}
                                    >
                                        @draemilysantos
                                    </a>
                                </p>
                                <p>
                                    <i className="bi bi-whatsapp"></i>
                                    <a
                                        href="https://wa.me/5511939300849"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: 'var(--azul-claro)', textDecoration: 'none' }}
                                    >
                                        Fale conosco pelo WhatsApp
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <h3 style={{ color: 'var(--azul-claro)', marginBottom: '20px', fontSize: '1.3rem' }}>
                                Nossa Missão
                            </h3>
                            <div className="footer-mission">
                                <p style={{ marginBottom: 0, fontSize: '1.05rem' }}>
                                    "Tornar o atendimento odontológico <strong>acessível</strong>,
                                    <strong> técnico</strong> e <strong>humano</strong>."
                                </p>
                            </div>

                            <div className="mt-4">
                                <h4 style={{ color: 'var(--azul-claro)', fontSize: '1.1rem', marginBottom: '15px' }}>
                                    Todos os Serviços
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2' }}>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Facetas em Resina</li>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Clareamento Dental</li>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Aparelhos Ortodônticos</li>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Preenchimento Labial</li>
                                    <li><i className="bi bi-check-circle-fill" style={{ color: 'var(--azul-claro)', marginRight: '10px' }}></i>Botox</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <p>&copy; 2026 Luppe Saúde - Odontologia. Todos os direitos reservados.</p>
                        <p>
                            Desenvolvido com <i className="bi bi-heart-fill" style={{ color: '#FF4757' }}></i> para transformar sorrisos na Zona Sul de SP
                        </p>
                    </div>
                </div>
            </footer>

            {/* Sticky CTA Mobile */}
            {showSticky && (
                <div
                    onClick={() => handleWhatsAppClick('sticky_mobile')}
                    className="sticky-cta-mobile"
                    style={{ cursor: 'pointer' }}
                    title="Agendar Avaliação"
                >
                    {notificationText && (
                        <div className="whatsapp-notification">
                            {notificationText}
                        </div>
                    )}
                    <i className="bi bi-whatsapp"></i>
                </div>
            )}
        </div>
    );
}

export default ClinicaLP;
